import { render, staticRenderFns } from "./MonthCalendar.vue?vue&type=template&id=8fbd6652&scoped=true"
import script from "./MonthCalendar.vue?vue&type=script&lang=js"
export * from "./MonthCalendar.vue?vue&type=script&lang=js"
import style0 from "./MonthCalendar.vue?vue&type=style&index=0&id=8fbd6652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbd6652",
  null
  
)

export default component.exports